import React from 'react'

const ReturnPolicy = () => {
    return (
        <div>
            <h2 className="font-bold text-xl mb-4">Return Policy</h2>
            <p>
                We want you to be fully satisfied with your purchase. If you are not happy with your product, you may return it within 7 days of delivery, provided the item is unused, undamaged, and in its original packaging.
            </p>
            <p>
                To initiate a return, please contact our customer support with your order ID and reason for return. Once approved, you will receive return instructions. Refunds will be processed after the product is received and inspected.
            </p>
            <p>
                Certain items such as perishable goods, personal care items, or customized products are non-returnable. Please check product details carefully before purchase.
            </p>
            <p>
                Refunds may take 5-7 business days to reflect in your original payment method. Shipping charges are non-refundable unless the return is due to our error or a defective product.
            </p>
        </div>

    )
}

export default ReturnPolicy